import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import Routes from './routes';

const App: React.FC = (): React.ReactElement => {
  return <Routes />;
};

export default App;
